import { useState } from "react";
import axios from "axios";
import { ArrowUpRight, Loader2, CheckCircle2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function WaitlistForm({ idPrefix = "waitlist", dark = false, onSuccess }) {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");
  const [message, setMessage] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim() || state === "loading") return;
    setState("loading");
    setMessage("");
    try {
      const res = await axios.post(`${API}/waitlist`, { email: email.trim() });
      setState("success");
      setMessage(res.data.message || "You're on the list.");
      onSuccess?.();
    } catch (err) {
      setState("error");
      setMessage(err?.response?.data?.detail || "Something went wrong — please try again.");
    }
  };

  if (state === "success") {
    return (
      <div
        data-testid={`${idPrefix}-success-message`}
        className={`flex items-center gap-3 rounded-2xl border px-5 py-4 max-w-md ${
          dark ? "border-white/15 bg-white/5 text-[#EAE5DC]" : "border-bronze/30 bg-white/70 text-ink"
        }`}
      >
        <CheckCircle2 className="h-5 w-5 shrink-0 text-bronze" />
        <p className="text-sm font-medium">{message}</p>
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid={`${idPrefix}-form`} className="w-full max-w-md">
      <div
        className={`flex items-center gap-2 rounded-full border p-1.5 transition-colors duration-300 ${
          dark
            ? "border-white/15 bg-white/5 focus-within:border-bronze/60"
            : "border-ink/15 bg-white/70 backdrop-blur-sm focus-within:border-bronze/60"
        }`}
      >
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@example.com"
          data-testid={`${idPrefix}-email-input`}
          className={`flex-1 min-w-0 bg-transparent outline-none px-4 text-sm ${
            dark ? "text-[#EAE5DC] placeholder:text-[#EAE5DC]/40" : "text-ink placeholder:text-ink-muted"
          }`}
        />
        <button
          type="submit"
          disabled={state === "loading"}
          data-testid={`${idPrefix}-submit-button`}
          className="group shrink-0 inline-flex items-center gap-1.5 rounded-full bg-bronze text-sand px-5 sm:px-6 py-3 text-sm font-semibold transition-all duration-300 hover:bg-bronze-hover hover:shadow-[0_10px_30px_rgba(200,90,50,0.4)] disabled:opacity-70"
        >
          {state === "loading" ? (
            <Loader2 className="h-4 w-4 animate-spin" />
          ) : (
            <>
              Join Waitlist
              <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
            </>
          )}
        </button>
      </div>
      {state === "error" && (
        <p data-testid={`${idPrefix}-error-message`} className={`mt-3 text-sm ${dark ? "text-amber-200" : "text-bronze"}`}>
          {message}
        </p>
      )}
    </form>
  );
}
